<ion-header>
  <ion-toolbar>
    <ion-icon name="dp-cross" (click)="dismiss()"></ion-icon>
    <ion-title>Configuración de reparto</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="delivery_list">
    <div class="first_line">
      <ion-button (click)="addLine()" fill="clear" class="general">
        Añadir nuevo elemento
        <ion-icon name="dp-plus-btn"></ion-icon>
      </ion-button>
    </div>

    <ion-reorder-group (ionItemReorder)="doReorder($event)" disabled="false">
      <div class="delivery_element" *ngFor="let elem of delivery; let index = index">
        <ion-reorder slot="start"></ion-reorder>

        <div class="input_box small">
          <ion-label class="text-sm-font-medium">Desde</ion-label>
          <ion-input class="general" [(ngModel)]="elem.startTime">
          </ion-input>
        </div>
        <div class="input_box small">
          <ion-label class="text-sm-font-medium">Hasta</ion-label>
          <ion-input class="general" [(ngModel)]="elem.endTime">
          </ion-input>
        </div>

        <div class="input_box">
          <ion-label class="text-sm-font-medium">Zona</ion-label>
          <ion-select class="general" interface="popover" [(ngModel)]="elem.zone">
            <ion-select-option *ngFor="let zone of zones" [value]="zone._id">{{ zone.name }}</ion-select-option>
          </ion-select>
        </div>

        <div class="input_box">
          <ion-label class="text-sm-font-medium">Reparto</ion-label>
          <ion-select class="general" interface="popover" [(ngModel)]="elem.type">
            <ion-select-option *ngFor="let delivery of getDeliveryTypeList(elem.zone)" [value]="delivery">{{
              ('delivery_system.order_list.' + delivery) | translate }}</ion-select-option>
          </ion-select>
        </div>

        <ion-button (click)="removeLine(index)" fill="clear">
          <ion-icon name="dp-trash"></ion-icon>
        </ion-button>
      </div>
    </ion-reorder-group>

  </div>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <ion-button (click)="saveDeliverySystem()" fill="clear" class="general">
      Guardar
    </ion-button>
  </ion-toolbar>
</ion-footer>